var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingLot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1610_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6719 41.2109C63.6719 35.2877 58.8529 30.4688 52.9297 30.4688H38.2812C37.2027 30.4688 36.3281 31.3434 36.3281 32.4219V50C36.3281 51.0785 37.2027 51.9531 38.2812 51.9531H52.9297C58.8529 51.9531 63.6719 47.1342 63.6719 41.2109ZM40.2344 34.375H52.9297C56.699 34.375 59.7656 37.4416 59.7656 41.2109C59.7656 44.9803 56.699 48.0469 52.9297 48.0469H40.2344V34.375Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3906 41.2109C75.3906 28.826 65.3146 18.75 52.9297 18.75H26.5625C25.484 18.75 24.6094 19.6246 24.6094 20.7031V79.2969C24.6094 80.3754 25.484 81.25 26.5625 81.25H38.2812C39.3598 81.25 40.2344 80.3754 40.2344 79.2969V63.6719H52.9297C65.3146 63.6719 75.3906 53.5959 75.3906 41.2109ZM38.2812 59.7656C37.2027 59.7656 36.3281 60.6402 36.3281 61.7188V77.3438H28.5156V22.6562H52.9297C63.1607 22.6562 71.4844 30.9799 71.4844 41.2109C71.4844 51.442 63.1607 59.7656 52.9297 59.7656H38.2812Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 100C51.0787 100 51.9531 99.1256 51.9531 98.0469C51.9531 96.9682 51.0787 96.0938 50 96.0938C48.9213 96.0938 48.0469 96.9682 48.0469 98.0469C48.0469 99.1256 48.9213 100 50 100Z",
    fill: "#7A297F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1875 0H7.8125C3.50469 0 0 3.50469 0 7.8125V92.1875C0 96.4953 3.50469 100 7.8125 100H41.2109C42.2895 100 43.1641 99.1254 43.1641 98.0469C43.1641 96.9684 42.2895 96.0938 41.2109 96.0938H7.8125C5.65859 96.0938 3.90625 94.3414 3.90625 92.1875V7.8125C3.90625 5.65859 5.65859 3.90625 7.8125 3.90625H92.1875C94.3414 3.90625 96.0938 5.65859 96.0938 7.8125V92.1875C96.0938 94.3414 94.3414 96.0938 92.1875 96.0938H58.7891C57.7105 96.0938 56.8359 96.9684 56.8359 98.0469C56.8359 99.1254 57.7105 100 58.7891 100H92.1875C96.4953 100 100 96.4953 100 92.1875V7.8125C100 3.50469 96.4953 0 92.1875 0Z",
    fill: "#7A297F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1610_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingLot);
export default __webpack_public_path__ + "static/media/parking-lot.12aa0cf98724f2e28c5ae9653d66bab8.svg";
export { ForwardRef as ReactComponent };